export default __webpack_public_path__ + "static/media/books-2048w.5f70aa52.webp";